module.exports = __webpack_public_path__ + "static/media/destacados-7.49698dd2.png";